import { StepsContext } from '../context/StepsContext';
import { useContext, useState } from 'react';
import { useEffect } from 'react';
import { Question } from '@iq-solutions/nida-shared';

interface QuestionInt {
  onSelection(questionId: number, value: string, drugs: string): void;
  questionData: Question;
}

const question = ({ questionData, onSelection }: QuestionInt): JSX.Element => {
  const qContext = useContext(StepsContext);

  const [checkAnswers, setCheckAnswers] = useState<string>(
    qContext.answers[questionData.id] ? qContext.answers[questionData.id].answer : '',
  );

  useEffect((): void => {
    onSelection(questionData!.id, checkAnswers, questionData.drugs[0]);
  }, [checkAnswers]);

  const onValueChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
    let answer = evt.target.value;
    setCheckAnswers(answer);
  };

  let maybeReversedAnswers = [...questionData?.answers].reverse();
  // if (questionData?.answers.length === 2) {
  //   // If a yes-no answer, Keep order No, Yes.
  //   maybeReversedAnswers = maybeReversedAnswers;
  // } else {
  //   // If longer answer, end with None of the above. Reverse order.
  //   maybeReversedAnswers = maybeReversedAnswers.reverse();
  // }
  console.log('maybeReversedAnswers');
  console.log(maybeReversedAnswers);
  console.log('/maybeReversedAnswers');

  return (
    <div className="question">
      <h2 dangerouslySetInnerHTML={{ __html: questionData.title }}></h2>
      <form>
        <div className="radio-container">
          {maybeReversedAnswers.map((txt: string, index: number) => (
            <div key={questionData.id + index} className="radio-set">
              <input
                type="radio"
                value={txt}
                id={questionData.id + txt}
                name={questionData?.title}
                checked={checkAnswers === txt.toLowerCase()}
                onChange={onValueChange}
              />
              <label htmlFor={questionData.id + txt}>{txt}</label>
            </div>
          ))}
        </div>
      </form>
    </div>
  );
};
export default question;
